import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SongItemWrapper from '../SongItemWrapper/SongItemWrapper';
import SongItem from '../SongItem/SongItem';
import PopUp from '../../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {  goToPage } from '../../fundialSlice';
import { Col, Row } from 'reactstrap';

const BusinessDownloadSongPopUp = (props) => {

    return (
        <div className="business-downloadSong-popUp">

            {props.audio ?
                <PopUp showPopUp={props.showPopUp} onClose={() => { props.closePopUp() }}>

                    <h1 className="title">שימו לב!</h1>
                    <p className="text">הנכם מנויים בשרות Business Tone ולכן לא ניתן להחליף את השיר הראשי הקיים.
                                        באפשרותכם להגדיר את השיר שבחרתם רק לאנשי קשר ספציפיים.</p>

                    <SongItemWrapper audio={props.audio} isDownloadMode={false} isPlaylistMode={false} songId={props.audio.id}  >
                        <SongItem isDisplayPlayer={true} playerSize={87} isDetailsFromLeft={true} audio={props.audio} onClickSong={()=> {}}  ></SongItem>
                    </SongItemWrapper>
                    <br />
                    <Row>
                        <Col xs="5" sm="5" md="5">
                            <div className='btn-white'>
                                <button className='btn-white__body unselected' onClick={() => {props.goToPage({page: 'catalogPage'})}}>
                                    <span className='btn-white__text'>לא מעוניין</span>
                                </button>
                            </div>
                        </Col>
                        <Col xs="7" sm="7" md="7" style={{ paddingRight: '0px' }}>
                            <BtnSubmit
                                onclick={() => {
                                    props.continueBtn()
                                }}
                                text="המשך הורדה"
                            />
                        </Col>
                    </Row>

                </PopUp>
                : null
            }


        </div>
    )
};

const mapStateToProps = (state) => {
    return {
        audio: state.fundialPage.selectedSong,
    };
};

const mapDispatchToProps = {
    goToPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessDownloadSongPopUp);